import React, { Fragment } from 'react'
import FieldLogo from '../FieldLogo'

const PrintTemplateHeader = ({
  title,
  config = {},
  subtitle
}) => {
  const isShelflifeCore = !config || config.app === 'shelflife'
  const logoUrl = config.logoUrlWhite || config.logoUrl

  return (
    <div className='print-template__header vs-u-align-center'>
      <div>
        <h1 className='print-template__title'>
          {title}
        </h1>
        {subtitle && (
          <h2 className='print-template__subtitle'>
            {subtitle}
          </h2>
        )}
      </div>
      {isShelflifeCore ? (
        <Fragment>
          <div className='print-template__brand'>
            <FieldLogo className='print-template__logo print-template__logo--field' fill='#fff' />
            <span className='print-template__entity'>
              Field Technology Development Partners (Shelf Life)
            </span>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <span className='vs-u-visually-hidden'>
            {config.name}
          </span>
          {logoUrl && (
            <img
              src={logoUrl}
              alt={`${config.name} Logo`}
              className='print-template__logo'
            />
          )}
        </Fragment>
      )}
    </div>
  )
}

export default PrintTemplateHeader
